import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload",
  "use": "icon-upload-usage",
  "viewBox": "0 0 26 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 32\" id=\"icon-upload\"><g id=\"icon-upload_Layer_2\" data-name=\"Layer 2\"><g id=\"icon-upload_Layer_1-2\" data-name=\"Layer 1\"><path class=\"cls-1\" d=\"M24.23,6.23A7.09,7.09,0,0,1,26,10H16V0a7.09,7.09,0,0,1,3.77,1.74ZM14,12V0H2.5A2.51,2.51,0,0,0,0,2.5v27A2.51,2.51,0,0,0,2.5,32h21A2.51,2.51,0,0,0,26,29.5V12Zm2,12v6H10V24H5l8-8,8,8Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol